import React, { JSX } from "react";
import styled, { css } from "styled-components";
import { DefaultTheme } from "styled-components";

type Variant =
  | "hero"
  | "display"
  | "title"
  | "heading1"
  | "heading2"
  | "heading3"
  | "heading4";

export interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
  as?: keyof JSX.IntrinsicElements; // e.g. h1, h2, h3...
  variant?: Variant;
  align?: "left" | "center" | "right";
  color?: keyof DefaultTheme["colors"] | string;
  maxWidth?: string;
}

const StyledHeading = styled.h1<HeadingProps>`
  ${({ theme, variant = "heading1", align = "left", color = "textPrimary", maxWidth }) => {
    const styles = theme.typography[variant];
    return css`
      font-family: ${theme.fonts.fontFamily};
      font-size: ${styles.fontSize};
      font-weight: ${styles.fontWeight};
      line-height: ${styles.lineHeight};
      letter-spacing: ${styles.letterSpacing};
      color: ${theme.colors[color as keyof typeof theme.colors] || color};
      text-align: ${align};
      margin: 0;
      ${maxWidth && `max-width: ${maxWidth};`}
      @media (max-width: ${theme.breakpoints.tablet}) {
        font-size: ${styles.mobileSize};
        line-height: ${styles.mobileLineHeight};
      }
    `;
  }}
`;

export const Heading: React.FC<HeadingProps> = ({
  as = "h2",
  variant = "heading1",
  children,
  ...rest
}) => {
  return (
    <StyledHeading as={as} variant={variant} {...rest}>
      {children}
    </StyledHeading>
  );
};

export default Heading;